<template>
  <div class="merge-field-container">{{ value }}</div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent, computed } from 'vue';
import type { Field } from '../types/field';

export default defineComponent({
  props: {
    field: {
      type: Object as PropType<Field>,
      required: true,
    },
  },
  setup(props) {
    const value = computed(() => props.field.value || props.field.label || '');

    return {
      value,
    };
  },
});
</script>

<style lang="scss" scoped>
.merge-field-container {
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: normal;
  font-weight: normal;
  color: var(--text-dark);
}
</style>
